// Core
import React from 'react';
// Material UI
import { Typography, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
// Styles
import { useRowStyles } from './row.style';
// Component method core
import { convertStringToArray, hasFirstElement } from './row.core';
// Styles
import { overrideStyles } from '../../helpers/styles';
/**
 * Row component
 * @param props - Row component properties
 */
var Row = function (props) {
    var onClick = props.onClick, openRow = props.openRow, lastElement = props.lastElement;
    /** External component classes */
    var externalClasses = props.classes;
    /** Merged component classes */
    var classes = overrideStyles(useRowStyles(), externalClasses);
    /** Current content */
    var currentContent = props.content || props.contentList;
    /** Current root class name */
    var currentRootClassName = openRow ? classes.root + " " + classes.rootActive : classes.root;
    /** List icon component */
    var listIcon = hasFirstElement(props) ? (React.createElement(ListItemIcon, { className: classes.listItemIcon }, props.icon)) : null;
    /** List item component */
    var listItem = currentContent ? (React.createElement(ListItemText, { className: classes.listItemText }, convertStringToArray(currentContent).map(function (text, index) { return (React.createElement(Typography, { className: classes.typography, key: index, align: "left" }, text)); }))) : null;
    return (React.createElement(ListItem, { button: true, className: currentRootClassName, onClick: onClick },
        listIcon,
        listItem,
        lastElement));
};
export default React.memo(Row);
//# sourceMappingURL=Row.js.map